__turbopack_context__.v({
  "className": "hanken_grotesk_103b81ad-module__jfNpxW__className",
});
